export default __webpack_public_path__ + "39b3cb11ad204a6908379ead7410b6c8.png";